import React from 'react'
import { minorScale, majorScale, defaultTheme } from 'evergreen-ui'
import CircleIconWrapper from 'components/Icons/CircleIconWrapper'
import OriginalSourceIcon from 'components/Icons/Sources'

const SourceIcon = () => (
  <CircleIconWrapper
    background="greenTint"
    margin={0}
    size={majorScale(3)}
    icon={
      <OriginalSourceIcon
        fill={defaultTheme.palette.green.base}
        size={minorScale(3)}
      />
    }
  />
)

export default SourceIcon
